import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📚 MegaPack Universitario Elite (12 Tomos)',
  price: '$19.990'
}, {
  label: '🎁 Diagnóstico Anti-Recursada',
  price: 'GRATIS'
}, {
  label: '🎁 Planificador Cuatrimestral Elite',
  price: 'GRATIS'
}, {
  label: '🎁 Checklist Final sin Pánico',
  price: 'GRATIS'
}, {
  label: '🎁 Plantillas de Apuntes Inteligentes',
  price: 'GRATIS'
}, {
  label: '🎁 Prompts de IA para Estudiar Más Rápido',
  price: 'GRATIS'
}, {
  label: '🛡️ Garantía 7 días',
  price: 'INCLUIDA'
}];
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago · Tarjeta'
}];
export function ValueStack() {
  return <section id="value" aria-label="Resumen de la oferta" className="bg-ink-2 border-y border-white/5" data-id="element-186" data-mp="35pd4rm7gorhs">
      <div className="mx-auto max-w-2xl px-5 py-20 text-center pb-[21px] pt-[32px]" data-id="element-187" data-mp="1tgeli5i3pywd">
        <h2 className="font-display text-2xl font-black text-white sm:text-4xl" data-id="element-188" data-mp="1ogs4rm32e0it">
          🚀 Empezá a aprobar desde hoy
        </h2>
        <p className="mt-3 text-sm text-white/60" data-id="element-189" data-mp="236r0zjb271vn">
          Un pago único. Acceso de por vida. Sistema listo para aplicar en minutos.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-white/10 bg-ink text-left" data-id="element-190" data-mp="2c5kuh0t3fc4z">
          <div className="flex items-center justify-between border-b border-white/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-white/50" data-id="element-191" data-mp="284j3t8d8s8em">
            <span data-id="element-192" data-mp="2m392utjmgi5m">Qué incluye</span>
            <span data-id="element-193" data-mp="2h4xr2d9rnxkr">Precio</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-white/5 px-5 py-3.5 text-sm" data-id="element-194" data-mp="2h5h35dcqjrqv">
              <span className="text-white/80" data-id="element-195" data-mp="rru981nhpykl">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-white' : 'shrink-0 font-bold text-gold'} data-id="element-196" data-mp="mshd0qaqbf5c">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-wrap items-center justify-between gap-2 bg-verde/10 px-5 py-4" data-id="element-197" data-mp="2rt1ysu7is295">
            <span className="text-sm font-bold text-white" data-id="element-198" data-mp="2vt2ojb02jzvi">
              Valor total real: <span className="text-white/40 line-through" data-id="element-199" data-mp="30t7674cpr0nb">$101.940</span>
            </span>
            <span className="font-display text-2xl font-black text-gold-shine" data-id="element-200" data-mp="35sjt1p3l47pw">$19.990 ARS</span>
          </div>
        </div>

        <div className="mt-9" data-id="element-201" data-mp="3aptpvptazlnr">
          <CTAButton href="https://megapack-universitario-elite.impultienda.ar/checkout" data-id="element-202" data-mp="3ap0eucnba9zt">
            Sí, quiero aprobar sin recursar
          </CTAButton>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-203" data-mp="3ji55shqsjqph">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-204" data-mp="3tinrzj5tvjak">
              <Icon className="h-4 w-4 text-gold" data-id="element-205" data-mp="7gomsge6kms2" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}